import React from 'react'
import { RadioCircle, RadioInner, RadioLabel ,RadioButtonListContainer} from './styled'
import { Text2 } from '../../ui/text'
import useIsMobile from '../../../hooks/useIsMobile'
import colors from '../../../styles/colors'

  const sortOptions = [
    { id: 'fecha', label: 'Fecha' },
    { id: 'clinica', label: 'Clínica' },
    { id: 'numero', label: 'Número de orden' },
  ]
  
export const RadioButton = ({ checked, onChange, label }) => {
  const isMobile = useIsMobile()
  return (
    <RadioLabel onClick={onChange}>
      {
        isMobile && (
          <Text2 color={colors.text.primaryText}>{label}</Text2>
        )
      }
      <RadioCircle checked={checked}>
        <RadioInner checked={checked} />
      </RadioCircle>
        {
        !isMobile && (
          <Text2 color={colors.text.primaryText}>{label}</Text2>
        )
      }
    </RadioLabel>
  )
}

const RadioButtonList = ({
  options = [],
  selected,
  onChange = () => {},
  maxWidth,
}) => {
  return (
    <RadioButtonListContainer maxWidth={maxWidth}>
      {options.map(option => (
        <RadioButton
          key={option.id}
          checked={selected === option.id}
          onChange={() => onChange(option.id)}
          label={option.label}
        />
      ))}
    </RadioButtonListContainer>
  )
}

export default RadioButtonList
